if (!window.multicolumnAddToCartInitialized) {
  window.multicolumnAddToCartInitialized = true;

  const openMulticolumnCart = async (result, button) => {
    const cartly = window.Spurit?.OneClickCheckout3?.cartDrawer;
    if (cartly?.refresh && cartly?.show) {
      await cartly.refresh();
      cartly.show();
      return;
    }
    const icon = document.getElementById('cart-icon-bubble');
    const marker = icon?.getAttribute('data-occ3-cart-icon');
    if (marker !== null && marker !== undefined) {
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.setAttribute('data-occ3-cart-icon', marker || '1');
      document.body.appendChild(trigger);
      trigger.click();
      trigger.remove();
      return;
    }
    if (window.Shopify?.actions?.openCart) {
      await window.Shopify.actions.openCart();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && result.sections) {
      drawer.setActiveElement?.(button);
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      return;
    }
    const notification = document.querySelector('cart-notification');
    if (notification?.renderContents && result.sections && result.items?.[0]) {
      notification.renderContents({ ...result, key: result.items[0].key });
    }
  };

  const addMulticolumnProductToCart = async (form, button) => {
    if (form.dataset.loading === 'true' || button.disabled) return;
    const status = form.querySelector('[data-multicolumn-cart-error]');
    const showStatus = (message = '') => {
      if (!status) return;
      status.textContent = message;
      status.hidden = !message;
    };
    if (window.Shopify?.designMode) {
      showStatus(form.dataset.previewMessage);
      return;
    }
    const fields = new FormData(form);
    const variantId = String(fields.get('id') || '');
    const quantity = Number(fields.get('quantity'));
    const genericError = form.dataset.errorGeneric;
    const uncertainError = form.dataset.errorUncertain || genericError;
    let endpoint;
    try {
      endpoint = new URL(form.dataset.addUrl, window.location.origin);
      if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(Number(variantId)) || Number(variantId) < 1 ||
          !Number.isInteger(quantity) || quantity < 1 || quantity > 20 ||
          endpoint.origin !== window.location.origin || !/\/cart\/add\.js$/.test(endpoint.pathname)) throw new Error();
    } catch {
      showStatus(genericError);
      return;
    }
    if (window.ForcedOutOfStock?.isBlockedVariant(variantId)) {
      showStatus(window.ForcedOutOfStock.soldOutText || genericError);
      return;
    }
    form.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    showStatus();
    try {
      const cartInterface = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cartInterface?.getSectionsToRender?.().map(section => section.id) || [];
      if (document.getElementById('cart-icon-bubble') && !sections.includes('cart-icon-bubble')) sections.push('cart-icon-bubble');
      const body = { items: [{ id: Number(variantId), quantity }] };
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(endpoint.href, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        const message = result.description || result.message;
        showStatus(response.status >= 500 ? uncertainError : (typeof message === 'string' ? message : genericError));
        return;
      }
      if (!Array.isArray(result.items) || !result.items.some(item => String(item.id) === variantId)) {
        showStatus(uncertainError);
        return;
      }
      showStatus(form.dataset.successMessage);
      try {
        if (typeof result.sections?.['cart-icon-bubble'] === 'string') {
          const template = document.createElement('template');
          template.innerHTML = result.sections['cart-icon-bubble'];
          const source = template.content.querySelector('.shopify-section');
          const target = document.getElementById('cart-icon-bubble');
          if (source && target) target.innerHTML = source.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'multicolumn-add-to-cart', productVariantId: variantId, cartData: result });
        }
      } catch {}
      try { await openMulticolumnCart(result, button); } catch {}
    } catch {
      showStatus(uncertainError);
    } finally {
      delete form.dataset.loading;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-multicolumn-cart-submit]');
    const form = button?.closest('form[data-multicolumn-add-to-cart]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addMulticolumnProductToCart(form, button);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[data-multicolumn-add-to-cart]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-multicolumn-cart-submit]');
    if (button) addMulticolumnProductToCart(form, button);
  });
}

customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('yg-multicolumn-slider')) return;
  customElements.define('yg-multicolumn-slider', class extends customElements.get('slider-component') {
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      if (this.sliderItemOffset <= 0) return;
      const gap = this.sliderItemOffset - this.sliderItemsToShow[0].clientWidth;
      this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth + gap + 1) / this.sliderItemOffset));
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }
  });
});
